<template>
  <div class="summary">
    <div class="panels form-section">
      <div class="panel-left-flex panel-left-gap">
        <h4>Requirements</h4>
        <div class="form-section">
          <div class="checkboxlabel" :class="{ on: isRefundable === true }" @click="isRefundable = !isRefundable">
            <div class="checkbox" />
            <label>Must the rate be refundable?</label>
          </div>
        </div>
        <div class="form-section">
          <label>What is your bed preference?</label>
          <textarea v-model="bed" placeholder="Optional" />
        </div>
        <div class="form-section">
          <label>Any other hotel requirements?</label>
          <textarea v-model="other" placeholder="Optional" />
        </div>
      </div>
      <div class="panel-right-flex panel-right-gap">
        <h4>Summary</h4>
        <HotelItineraryAssist :hotels="hotels" />
      </div>
    </div>
    <div id="navigation">
      <button @click="next">Next Step</button>
      <a @click="back">Back</a>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";

import HotelItineraryAssist from "./TripNewBookSummaryHotelAssist.vue";

const emit = defineEmits(["complete", "scroll", "update:isSavedRoute", "update:hotelsOther"]);
defineProps(["hotels"]);

const isRefundable = ref(false);
const bed = ref(null);
const other = ref(null);
const otherFormatted = computed(() => {
  var desc = "Refundable: " + (isRefundable.value ? "Yes" : "No") + "\n";
  desc += "Bed: " + (bed.value ? bed.value : "NA") + "\n";
  desc += "Other: " + (other.value ? other.value : "NA");
  return desc;
});

const back = () => {
  emit("update:isSavedRoute", false);
};

const next = () => {
  emit("update:hotelsOther", otherFormatted.value);
  emit("complete");
  emit("scroll");
};
</script>
